import React, { useRef, useState } from 'react';
import {
  Typography,
  Paper,
  Button,
  Grid,
  Divider,
  Box
} from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import TemplateTree from '../components/TemplateTree';
import DocumentProcessor from '../components/DocumentProcessor';
import { useTranslation } from '../hooks/useTranslation';

const EditorTemplates = () => {
  const fileInputRef = useRef(null);
  const templateTreeRef = useRef(null);
  const [currentTemplateData, setCurrentTemplateData] = useState(null);
  const history = useHistory();
  const { t } = useTranslation('editor');

  const handleImportClick = () => {
    fileInputRef.current.click();
  };

  const handleFileImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const json = JSON.parse(e.target.result);
        if (templateTreeRef.current) {
          templateTreeRef.current.importJson(json);
        }
      } catch (error) {
        alert(t('importError'));
        console.error('Erro de importação:', error);
      }
    };
    reader.readAsText(file);
    
    // Limpar o valor do input para permitir selecionar o mesmo arquivo novamente
    event.target.value = null;
  };

  const handleExportClick = () => {
    if (templateTreeRef.current) {
      const json = templateTreeRef.current.exportJson();
      setCurrentTemplateData(json);
      
      // Criar um blob com o JSON formatado
      const blob = new Blob([JSON.stringify(json, null, 2)], { type: 'application/json' });
      
      // Criar uma URL para o blob
      const url = URL.createObjectURL(blob);
      
      // Criar um link para download e clicar nele
      const a = document.createElement('a');
      a.href = url;
      a.download = 'template_ikaro.json';
      document.body.appendChild(a);
      a.click();
      
      // Limpar recursos
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  };

  return (
    <>
      <Paper elevation={3} style={{ padding: 24, marginBottom: 20 }}>
        <Grid container alignItems="center" justifyContent="space-between" style={{ marginBottom: 16 }}>
          <Grid item>
            <Typography variant="h5">
              <Box fontWeight="fontWeightBold">
                {t('title')}
              </Box>
            </Typography>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={() => history.push('/processamentos')}
              color="primary"
            >
              {t('backToProcessings')}
            </Button>
          </Grid>
        </Grid>
        <Divider style={{ marginBottom: 16 }} />
        <Typography paragraph>
          {t('description')}
        </Typography>
      </Paper>

      <DocumentProcessor templateData={currentTemplateData} />

      <Paper elevation={3} style={{ padding: 24, marginTop: 20 }}>
        <Grid container alignItems="center" justifyContent="space-between" style={{ marginBottom: 16 }}>
          <Grid item>
            <Typography variant="h6">
              <Box fontWeight="fontWeightBold">
                {t('dataStructure')}
              </Box>
            </Typography>
          </Grid>
          <Grid item>
            <input
              type="file"
              accept=".json"
              ref={fileInputRef}
              onChange={handleFileImport}
              style={{ display: 'none' }}
            />
            <Button 
              variant="outlined" 
              color="primary" 
              onClick={handleImportClick}
              style={{ marginRight: 8 }}
            >
              {t('importJson')}
            </Button>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleExportClick}
            >
              {t('exportJson')}
            </Button>
          </Grid>
        </Grid>

        <Divider style={{ marginBottom: 16 }} />
        
        <TemplateTree 
          ref={templateTreeRef} 
          onDataChange={(data) => setCurrentTemplateData(data)}
        />
      </Paper>
    </>
  );
};

export default EditorTemplates; 